import { BrowserModule } from '@angular/platform-browser';
import { NgModule, PLATFORM_ID, APP_ID, provideAppInitializer, inject } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SideNavComponent } from './side-nav/side-nav.component';
import { AppTranslateModule } from './app-translate.module';
import { provideHttpClient } from '@angular/common/http';
import { ConfigService } from './common/config.service';
import { isPlatformBrowser } from '@angular/common';
import { AppConstants } from './app-constants';

const appInitializerFn = (configService: ConfigService, platformId: {}) => {
    if(!localStorage.getItem(AppConstants.LOCALE_LANGUAGE)){
        localStorage.setItem(AppConstants.LOCALE_LANGUAGE, navigator.language.split('-')[0]);
    }
    if (isPlatformBrowser(platformId)) {
        return () => configService.loadConfig();
    } else {
        return () => { };
    }
};

@NgModule({
    declarations: [
        AppComponent,
        SideNavComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        AppTranslateModule,
        BrowserAnimationsModule,
        MatToolbarModule,
        MatSidenavModule
    ],
    providers: [
        ConfigService,
        provideHttpClient(),
        { provide: APP_ID,  useValue: 'serverApp' },
        provideAppInitializer(() => {
            appInitializerFn(inject(ConfigService), PLATFORM_ID);})
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
